import { createSlice } from "@reduxjs/toolkit";
import { loadState } from "../LocalStorage/LocalStorage";

const defaultState = {
    access_token: "",
    user: "",
    cart: [],
    appReady: false,
};

const persisted = loadState("user", defaultState) || defaultState;

export const initialUserState = {
    ...persisted,
    appReady: !!persisted?.business_data?.business_token,
};

const UserSlice = createSlice({
    name: "Users",
    initialState: initialUserState,

    reducers: {

        setUser(state, action) {
            const user = action.payload
            state.user = user || {}
        },

        setAccessToken(state, action) {
            const access_token = action.payload
            state.access_token = access_token || ""
        },

        setBusinessData(state, action) {
            const business_data = action.payload
            state.business_data = business_data || ""
        },

        setutilitiesData(state, action) {
            const utilities = action.payload
            state.utilities = utilities || ""
        },

        setCartToken(state, action) {
            const cartToken = action.payload
            state.cartToken = cartToken || ""
        },

        setAppReady(state, action) {
            state.appReady = Boolean(action.payload)
        },



        // setCart(state, action) {
        //     const newItem = action.payload;
        //     const cart = state.cart || []
        //     const existingIndex = cart.findIndex(item => item.id === newItem.id);
        //     if (existingIndex !== -1) {
        //         cart[existingIndex] = {

        //             ...newItem
        //         };
        //     } else {
        //         cart.push(newItem);
        //     }
        //     state.cart = cart;
        // },

        setCart(state, action) {
            const newItem = action.payload;
            const cart = state.cart || [];

            const index = cart.findIndex(item => item.id === newItem.id);

            if (index !== -1) {
                cart[index] = {
                    ...cart[index],   // 👈 purana data
                    ...newItem        // 👈 naya update
                };
            } else {
                cart.push(newItem);    // naye item ke liye
            }

            state.cart = cart;
        },

        removeFromCart(state, action) {
            const idToRemove = action.payload
            state.cart = state.cart.filter(item => item.id !== idToRemove);
        },

        clearCart(state) {
            state.cart = [];
        }


    }
})

export const { setUser, setAccessToken, setBusinessData, setutilitiesData, setCartToken, setAppReady, setCart, removeFromCart, clearCart } = UserSlice.actions;

export default UserSlice;